import { ACCOUNT_ROUTE_NAME } from "@/libs/route-name";
export const addressPaymentRoute = () => {
  return {
    name: ACCOUNT_ROUTE_NAME.ADDRESS_PAYMENT,
    path: "account/address-payment",
    component: () => import("@/pages/address-payment/index.vue"),
    meta: {
      requireAuth: true
    }
  };
};
